import { Component, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Section } from 'src/app/core/models/DigitalKit';

interface Service {
  title: string;
  description: string;
  icon: string;
  link: string;
}

interface CaseItem {
  text: string;
  image: string;
  link: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: false
})
export class HomeComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Consultora de Estrategia y Transformación Digital');
  }

  sections: Service[] = [
    {
      title: 'DESARROLLO COMERCIAL',
      description: 'Impulsamos el crecimiento comercial optimizando ventas y mejorando la captación y fidelización de clientes.',
      icon: 'assets/img/app-development.webp',
      link: '/servicios/desarrollo-comercial'
    },
    {
      title: 'UX & UI DESIGN',
      description: 'Diseñamos experiencias digitales centradas en el usuario para maximizar la satisfacción y el engagement.',
      icon: 'assets/img/ux-ui-2.webp',
      link: '/servicios/ux-ui'
    },
    {
      title: 'CONSULTORÍA',
      description: 'Ayudamos en la definición de objetivos para lograr la transformación digital a través del desarrollo de planes estratégicos y estudios de mercado.',
      icon: 'assets/img/consultant-team.webp',
      link: '/servicios/consultoria-tecnologica'
    },
    {
      title: 'MARKETING DIGITAL',
      description: 'Ejecutamos las acciones online más eficaces que garanticen oportunidad de crecimiento, posicionamiento y ventas o captación de clientes.',
      icon: 'assets/img/marketing.webp',
      link: '/servicios/marketing-digital'
    },
    {
      title: 'ANALÍTICA Y DATOS',
      description: 'Medición, análisis y optimización de resultados para mejorar la toma de decisiones.',
      icon: 'assets/img/mantenimiento.jpg',
      link: '/servicios/mantenimiento'
    },
    {
      title: 'CONSULTORÍA DE IA',
      description: 'Identificamos cómo la inteligencia artificial puede transformar tus procesos y te acompañamos en implantarla, sin necesidad de conocimientos técnicos.',
      icon: 'assets/img/AI_Consultant.webp',
      link: '/servicios/consultoria-ia'
    }
  ]

  cards: Section[] = [
    {
      title: 'Innovación',
      description: 'Adaptados a un entorno cambiante para desarrollar soluciones innovadoras.',
      icon: 'assets/svg/brain.svg'
    },
    {
      title: 'Confianza',
      description: 'Nos convertimos en el socio de confianza atendiendo a las necesidades específicas de cada negocio.',
      icon: 'assets/svg/high-five.svg'
    },
    {
      title: 'Talento',
      description: 'Potenciamos el crecimiento profesional de nuestro equipo de trabajo.',
      icon: 'assets/svg/skills.svg'
    },
    {
      title: 'Calidad',
      description: '>Nuestro objetivo principal es brindar al cliente final una solución digital de calidad que le ayude a impulsar su negocio.',
      icon: 'assets/svg/quality.svg'
    }
  ]

  cases: CaseItem[] = [
    {
      text: 'Consultoría Digital',
      image: 'assets/img/consultoria33.jpg',
      link: '/proyectos/proyecto-consultoria'
    },
    {
      text: 'Estrategia y crecimiento digital',
      image: 'assets/img/caso2.jpg',
      link: '/proyectos/proyecto-crecimiento-digital'
    },
    {
      text: 'Optimización de Experiencia Digital',
      image: 'assets/img/git.webp',
      link: '/proyectos/proyecto-experiencia-digital'
    }
  ]
}
